import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase/firebaseConfig";
import logoImage from "../../assets/images/egs23.svg";
import { useUser } from "../../context/UserContext";

export const Header: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { userData } = useUser();

    const handleLogout = async () => {
        try {
            await signOut(auth);
            navigate("/"); // Redirect to login after logout
        } catch (error) {
            console.error("Error signing out:", error);
        }
    };

    // Function to check if the current route matches the target route
    const isActive = (path: string) => location.pathname === path ? 'active' : '';

    return (
        <div className="header-container">
            <header className="header">
                <nav>
                    <div className="nav-left">
                        <img
                            src={logoImage}
                            alt="Logo"
                            className="header-logo"
                            onClick={() => navigate('/dashboard')}
                        />
                    </div>

                    <label htmlFor="menu" className="hamburger">
                        <span></span>
                        <span></span>
                        <span></span>
                    </label>

                    <input id="menu" type="checkbox" className="menu-toggle" />

                    <ul className="nav-links">

                         <li className={isActive("/time-manager")} onClick={() => navigate("/time-manager")}>
                            Time Manager
                        </li>

                        <li className={isActive("/scheduler")} onClick={() => navigate("/scheduler")}>
                            Schedule
                        </li>

                        {userData?.admin && (
                            <li className={isActive("/payroll")} onClick={() => navigate("/payroll")}>
                                Payroll
                            </li>
                        )}
                        <li className={isActive("/dashboard")} onClick={() => navigate("/dashboard")}>
                            My Time
                        </li>
                        <li className={isActive("/profile")} onClick={() => navigate("/profile")}>
                            Profile
                        </li>
                        <li onClick={handleLogout}>Logout</li>
                    </ul>
                </nav>
            </header>
        </div>

    );
};

require("./styles.scss");
